import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'


Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
      {
          path: '/certificate',
          name: 'certificate',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "about" */ './views/Certificate.vue')
      },
      {
          path: '/pay',
          name: 'pay',
          component: () => import(/* webpackChunkName: "about" */ './views/Pay.vue')
      },

      {
          path: '/search',
          name: 'search',
          component: () => import(/* webpackChunkName: "about" */ './views/SearchCert.vue')
      },

      {
        path:'/h5pay',
        name:'wxh5pay',
        component:()=>import('./views/WxH5Pay.vue')

      }
      
  ]
})


router.beforeEach((to,from,next)=>{


       let enableLogin = false

       if(!enableLogin){

          next();

          return
       }

      let userId = sessionStorage.getItem('userId');

      if(userId){

          next();

      }else if(to.query.uid&&!userId){

          sessionStorage.setItem('userId',to.query.uid);
          next();
      } else  {

         location.href='https://admin.gzfp.org.cn/GZFPOneMeters/WxLogin?actId='+ (to.query.id||1)+'&iq='+to.query.iq+'&channel='+to.query.channel
      }


})

export default router;
